import React from 'react';
import PropTypes from 'prop-types';

import classes from './LandingMenuItems.css';
import LandingMenuItem from './LandingMenuItems/LandingMenuItem';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const landingMenuItems = props => {
  const { language } = props;
  return (
    <ul className={classes.LandingMenuItems}>
      <LandingMenuItem
        toPage="transformer-data"
        menuItemTitle={LocalizedStrings[language].transformerData}
        menuItemDesc={LocalizedStrings[language].transformerDataDesc}
      />
    </ul>
  );
};

landingMenuItems.propTypes = {
  language: PropTypes.string.isRequired
};

export default landingMenuItems;